export default __webpack_public_path__ + "static/media/fsw_4.92bc6f8e.png";